<template>
  <div class="panel panel-default">
    <div class="panel-heading">
      <label class="control-label">Recebedor</label>
    </div>
    <div class="panel-body panel-body--padding">
      <recipients-list-modal
        v-if="showRecipientsListModal"
        @selected-recipient="updateRecipient"
        @close="changeModalVisibility('showRecipientsListModal', false)"
      />
      <table
        v-if="true"
        class="table table-condensed table-bordered"
      >
        <thead>
          <tr>
            <th class="table-centralized col-md-1">
              Split
            </th>
            <th class="table-centralized">
              Nome
            </th>
            <th class="table-centralized">
              Documento
            </th>
            <th class="table-centralized">
              Tipo
            </th>
            <th class="table-centralized">
              Banco
            </th>
            <th class="table-centralized">
              Agência
            </th>
            <th class="table-centralized">
              Conta
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="selectedRecipient">
            <td class="table-centralized">
              <input-field
                input-group-text-append="%"
                :mask="'###'"
                v-model.number="splitRuleForm.get('percentage').value"
                :errors="splitRuleForm.get('percentage').errors"
                @input="emitSplitRuleFormFieldChanged('percentage')"
                @change="updateQueroPagoSplit"
                :disabled="disabledForm"
              />
            </td>
            <td>
              {{ selectedRecipient.name }}
            </td>
            <td>
              {{ selectedRecipient.documentType.toUpperCase() }}: {{ selectedRecipient.documentFormatted }}
            </td>
            <td>
              {{ selectedRecipient.bankAccount.translatedBankAccountType }}
            </td>
            <td>
              {{ selectedRecipient.bankAccount.bankCode }}
            </td>
            <td>
              {{ agency(selectedRecipient.bankAccount) }}
            </td>
            <td>
              {{ account(selectedRecipient.bankAccount) }}
            </td>
          </tr>
          <tr>
            <td>
              <input-field
                input-group-text-append="%"
                :mask="'###'"
                v-model.number="qpSplitRuleForm.get('percentage').value"
                :errors="qpSplitRuleForm.get('percentage').errors"
                @input="emitQueroPagoSplitRuleFormFieldChanged('percentage')"
                disabled
              />
            </td>
            <td>
              {{ qpRecipient.name }}
            </td>
            <td>
              CNPJ: {{ qpRecipient.documentFormatted }}
            </td>
            <td>
              {{ qpRecipient.bankAccount.translatedBankAccountType }}
            </td>
            <td>
              {{ qpRecipient.bankAccount.bankCode }}
            </td>
            <td>
              {{ agency(qpRecipient.bankAccount) }}
            </td>
            <td>
              {{ account(qpRecipient.bankAccount) }}
            </td>
          </tr>
        </tbody>
      </table>
      <button
        class="btn btn-primary"
        title="Selecionar recebedor"
        @click.prevent="changeModalVisibility('showRecipientsListModal', true)"
        :disabled="disabledForm"
      >
        <div v-if="!selectedRecipient">
          <i class="fas fa-plus"></i>
          Selecionar recebedor
        </div>
        <div v-else="!selectedRecipient">
          <i class="fas fa-plus"></i>
          Trocar recebedor
        </div>
      </button>
      <div class="pull-right">
        <router-link to="recebedores" target="_blank">
          Consultar dias de transferências
        </router-link>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
  @import 'assets/stylesheets/utils/_spacing.sass';

  .panel-body--padding {
    padding: $space-m $space-st $space-xxs $space-st;
  }
</style>
<script>
import { mapState } from 'vuex';
import { toCamelCase } from 'utils';
import { InputField } from 'components/form';
import RecipientsListModal from './RecipientsListModal';

export default {
  components: {
    InputField,
    RecipientsListModal,
  },
  props: {
    splitRuleForm: {
      type: Object,
      required: true,
    },
    qpSplitRuleForm: {
      type: Object,
      required: true,
    },
    selectedRecipient: {
      type: Object,
      default: null,
    },
    disabledForm: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      showRecipientsListModal: false,
      qpRecipient: null,
    };
  },
  computed: {
    ...mapState([
      'queroPagoRecipient',
    ]),
  },
  methods: {
    account(bankAccount) {
      if (bankAccount.digit) return `${bankAccount.number}-${bankAccount.digit}`;

      return bankAccount.number;
    },
    agency(bankAccount) {
      if (bankAccount.agencyDigit) return `${bankAccount.agencyCode}-${bankAccount.agencyDigit}`;

      return bankAccount.agencyCode;
    },
    changeModalVisibility(modalName, open) {
      this[modalName] = open;
    },
    updateRecipient(recipient) {
      this.splitRuleForm.addValues({ recipientId: recipient.id });
      this.$emit('update-recipient', recipient);
      this.emitSplitRuleFormFieldChanged('recipientId');
      this.changeModalVisibility('showRecipientsListModal', false);
    },
    updateQueroPagoSplit($event) {
      this.qpSplitRuleForm.addValues({ percentage: 100 - $event.target.value });
      this.emitQueroPagoSplitRuleFormFieldChanged('percentage');
    },
    emitSplitRuleFormFieldChanged(field) {
      this.$emit('split-rule-form-field-changed', { [field]: this.splitRuleForm.get(field).value });
    },
    emitQueroPagoSplitRuleFormFieldChanged(field) {
      this.$emit('qp-split-rule-form-field-changed', { [field]: this.qpSplitRuleForm.get(field).value });
    },
  },
  created() {
    this.qpRecipient = {
      ...toCamelCase(this.queroPagoRecipient),
      bankAccount: toCamelCase(this.queroPagoRecipient.bank_account),
    };
  },
};
</script>
